module.exports = __webpack_public_path__ + "static/media/bet-green-3.420911f1.png";